import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'deliveryTimeOpen',
  initialState: null as null | string,
  reducers: {
    setDeliveryTimeOpen(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setDeliveryTimeOpen } = slice.actions;

export default slice.reducer;
